import { RadioButtonGroupInput } from "react-admin";

const InUseInput = ({ ...props }) => (
  <RadioButtonGroupInput
    {...props}
    choices={[
      { id: "IN-USE", name: "Active" },
      { id: "Disabled", name: "Disabled" },
    ]}
  />
);

export default InUseInput;
